module.exports = __webpack_public_path__ + "img/EnergyViewV2.271b23a6.png";